import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { copyText } from "./ShareSheet";
import { BACKEND_URL } from "../../lib/api";

export const galleryLink = () => `${BACKEND_URL}/api/share/gallery`;
const TEXT = "Feeling Heart, an exhibition by Priyanka Jha · Rainbow by the Rain";
const opt = "w-full rounded-full border border-[#7E57C2]/25 bg-white/80 px-5 py-2.5 font-display text-lg text-[#2D1E3E] transition-colors duration-200 hover:bg-[#7E57C2] hover:text-white";

// Share options for the whole gallery (a link whose preview card shows the exhibition).
export function GalleryShare({ open, onClose }) {
  const [status, setStatus] = useState("");
  const link = galleryLink();
  const native = async () => {
    try {
      await navigator.share({ title: "Feeling Heart · Rainbow by the Rain", text: TEXT, url: link });
      setStatus("Shared");
    } catch (e) {
      if (e?.name !== "AbortError") setStatus("Couldn't open sharing, try copying the link");
    }
  };
  const copy = async () => setStatus((await copyText(link)) ? "Link copied" : "Couldn't copy, the link is shown below");
  return (
    <AnimatePresence>
      {open && (
        <motion.div data-testid="gallery-share" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} onClick={onClose} className="fixed inset-0 z-[96] flex items-center justify-center bg-[#2D1E3E]/30 p-4 backdrop-blur-sm">
          <motion.div initial={{ y: 16 }} animate={{ y: 0 }} onClick={(e) => e.stopPropagation()} className="flex w-full max-w-sm flex-col items-center gap-3 rounded-[2rem] bg-[#FBF7F2] px-7 py-7 text-center shadow-[0_30px_80px_-30px_rgba(45,30,62,0.6)]">
            <h2 className="font-display text-3xl italic text-[#2D1E3E]">Share the gallery</h2>
            <p className="font-display text-base italic text-[#5C4A72]">Invite someone to walk through Feeling Heart.</p>
            {navigator.share && (
              <button data-testid="gallery-share-native" onClick={native} className={opt}>
                Share…
              </button>
            )}
            <a data-testid="gallery-share-whatsapp" href={`https://wa.me/?text=${encodeURIComponent(`${TEXT} ${link}`)}`} target="_blank" rel="noreferrer" className={opt}>
              WhatsApp
            </a>
            <button data-testid="gallery-share-copy" onClick={copy} className={opt}>
              Copy the link
            </button>
            <p data-testid="gallery-share-status" role="status" className="min-h-[1.25rem] text-sm text-[#7E57C2]">
              {status}
            </p>
            {status.startsWith("Couldn't") && <p className="w-full truncate text-[11px] text-[#7C6992]">{link}</p>}
            <button data-testid="gallery-share-close" onClick={onClose} className="font-display text-base text-[#5C4A72] hover:text-[#2D1E3E]">
              Close
            </button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
